// extracted by mini-css-extract-plugin
export default {"desctiption_block":"AdvertisementDescriptionBlock_desctiption_block__QNjSS","shimmer":"AdvertisementDescriptionBlock_shimmer__PS4uz"};